import { render, staticRenderFns } from "./ProjectCollectionNew.vue?vue&type=template&id=40bc9f3e"
import script from "./ProjectCollectionNew.vue?vue&type=script&lang=ts"
export * from "./ProjectCollectionNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40bc9f3e')) {
      api.createRecord('40bc9f3e', component.options)
    } else {
      api.reload('40bc9f3e', component.options)
    }
    module.hot.accept("./ProjectCollectionNew.vue?vue&type=template&id=40bc9f3e", function () {
      api.rerender('40bc9f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectCollectionNew.vue"
export default component.exports